// extracted by mini-css-extract-plugin
export default {"rowsWrapper":"custom_fields_section-module___rowsWrapper___c7322fb5","addButton":"custom_fields_section-module___addButton___cab77d14"};